import authAPI from './modules/auth'
import pageAPI from './modules/page'
import productAPI from './modules/product'
import fileAPI from './modules/file'
import contentAPI from './modules/content'
import newsAPI from './modules/news'
import jobsAPI from './modules/jobs'
import jobApplicationsAPI from './modules/jobApplications'
import cooperationAPI from './modules/cooperation'
import bannerAPI from './modules/banner'
import cooperationCaseAPI from './modules/cooperationCase'
import contactInfoAPI from './modules/contactInfo'
/**
 * API接口统一管理
 * 整合所有功能模块的API接口，方便统一导入使用
 */
const api = {
  auth: authAPI,
  page: pageAPI,
  product: productAPI,
  file: fileAPI,
  content: contentAPI,
  news: newsAPI,
  jobs: jobsAPI,
  jobApplications: jobApplicationsAPI,
  cooperation: cooperationAPI,
  banner: bannerAPI,
  cooperationCase: cooperationCaseAPI,
  contactInfo: contactInfoAPI,
}

export default api

// 也可以按需导出各个模块
export { authAPI, pageAPI, productAPI, fileAPI, contentAPI, newsAPI, jobsAPI, jobApplicationsAPI, cooperationAPI, bannerAPI, cooperationCaseAPI, contactInfoAPI }